import {
  CollabFilterType,
  type MutableCollabFilter,
  type MutableCollabFilterBooleanExpression
} from '@databases/model/views/view-filter';
import {
  type DatabaseFilter,
  DatabaseFilterType,
  type DatabaseFilterBooleanExpression
} from '@databases/types/database/view';

export function isUsageFilter(
  filter: MutableCollabFilter | DatabaseFilter
): filter is UsageFilter {
  return (
    filter.type === CollabFilterType.AND ||
    filter.type === CollabFilterType.OR ||
    filter.type === DatabaseFilterType.AND ||
    filter.type === DatabaseFilterType.OR
  );
}

export type UsageFilter =
  | MutableCollabFilterBooleanExpression
  | DatabaseFilterBooleanExpression;
